import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import ClassesTable from '../../components/classes/ClassesTable';

const Classes = () => (<WrapperSection><GlobalBreadcrumbs /><ClassesTable /></WrapperSection>);
export default Classes;
